// The current_matches push and startup section: the user's current match, or
// `all_entries` alone when they have none. Applies on every page, not only the
// netplay page, because the match dock (react/dock) shows the match everywhere.
export default function applyCurrentMatches(currentMatches, { manager, matchmakingDisabled }) {
	if(matchmakingDisabled || !currentMatches) {
		return;
	}
	const ids = Object.keys(currentMatches).filter((key) => key !== 'all_entries');
	if(ids.length === 0 && currentMatches.all_entries) {
		manager.clearActiveMatch();
		return;
	}
	manager.parseSearches(currentMatches);
}
